import React, { Component } from 'react';
import { View, TextInput, TouchableOpacity, CheckBox, Text, StyleSheet, Linking, Alert } from 'react-native';
import Feather from 'react-native-vector-icons/Feather';
import { Ionicons } from '@expo/vector-icons';


export default class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      confirmPw: '',
      username: '',
      userSource: '',
      platformUsername: '',
      check_textInputChange: false,
      secureTextEntry: true,
      confirmSecureTextEntry: true,
      isSubmitting: false, // ✅ Prevents multiple taps
      isFollowing: false, // ✅ checkbox state
    };
  }

 

  componentDidMount() {
    Linking.getInitialURL()
      .then((url) => {
        if (url) {
          const referrerMatch = url.match(/SignUp\/([^/]+)/);
          if (referrerMatch) {
            const referrer = `Invited by ${decodeURIComponent(referrerMatch[1])}`;
            this.setState({ userSource: referrer }); // Set userSource with "Invited by <value>"
          }
        }
      })
      .catch((error) => {
        console.error('Error retrieving URL:', error);
      });
  }
  
  
  InsertRecord = () => {
    const {
      email,
      password,
      username,
      confirmPw,
      userSource,
      platformUsername,
      isSubmitting, // pull from state
    } = this.state;
  
    // ✅ If already submitting, prevent further action
    if (isSubmitting) {
      console.log('Already submitting...');
      return;
    }
  
    // ✅ Set the state to submitting
    this.setState({ isSubmitting: true });
  
    const checkEmail = RegExp(
      /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$/i
    );
  
    // Validation checks for input fields
    if (
      email.length === 0 ||
      password.length === 0 ||
      confirmPw.length === 0 ||
      username.length === 0 ||
      userSource.length === 0 ||
      platformUsername.length === 0
    ) {
      alert('Required Field Is Missing');
      this.setState({ isSubmitting: false }); // ✅ Reset submission flag
    } else if (!checkEmail.test(email)) {
      alert('Invalid email!');
      this.setState({ isSubmitting: false }); // ✅ Reset submission flag
    } else if (password.length < 8) {
      alert('Minimum 8 characters required');
      this.setState({ isSubmitting: false });
    } else if (!/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password)) {
      alert('Use at least 1 special character');
      this.setState({ isSubmitting: false });
    } else if (/\s/.test(password)) {
      alert("Don't include space in password");
      this.setState({ isSubmitting: false });
    } else if (password !== confirmPw) {
      alert('Password does not match');
      this.setState({ isSubmitting: false });
    } else {
      const InsertAPIURL = 'https://collabbay.com/SignUp.php';
  
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };
  
      const Data = {
        Email: email,
        Password: password,
        Username: username,
        UserSource: userSource,
        PlatformUsername: platformUsername,
      };
  
      fetch(InsertAPIURL, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(Data),
      })
        .then((response) => response.json())
        .then((response) => {
          console.log('API Response:', response);
  
          if (response && response.Status) {
            if (
              response.Status === 'Success' ||
              response.Status === 'PartialSuccess'
            ) {
              this.setState({ isSubmitting: false }); // ✅ Re-enable button
              Linking.openURL('https://collabbay.com/');
            } else {
              alert(response.Message || 'Registration failed. Please try again.');
              this.setState({ isSubmitting: false });
            }
          } else {
            alert('Unexpected response format or no message received');
            this.setState({ isSubmitting: false });
          }
        })
        .catch((error) => {
          alert('Error Occurred: ' + error);
          this.setState({ isSubmitting: false });
        });
    }
  };
  
  
  

  
  // Toggle password visibility for the password field
  updateSecureTextEntry = () => {
    this.setState({
      secureTextEntry: !this.state.secureTextEntry,
    });
  };

  // Toggle password visibility for the confirm password field
  updateConfirmSecureTextEntry = () => {
    this.setState({
      confirmSecureTextEntry: !this.state.confirmSecureTextEntry,
    });
  };

  render() {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
      <View style={[styles.container, { width: '100%', maxWidth: 600, alignSelf: 'center', backgroundColor: '#fff', flex: 1 }]}>
  
        {/* Back Button */}
        <TouchableOpacity style={styles.backButton} onPress={() => this.props.navigation.goBack()}>
          <Feather name="arrow-left" size={24} color="#000" />
        </TouchableOpacity>

        {/* Header */}

        <Text style={styles.header}>
  Sign Up Now
  <Text style={{ color: '#FDF05D' }}>.</Text>
</Text>

        <Text style={styles.subText}>Your collabs are waiting</Text>

        {/* Username Input */}
        <TextInput
          placeholder="Create Username"
          placeholderTextColor="#999"
          style={styles.textInput}
          onChangeText={(username) => this.setState({ username })}
        />

        {/* Email Input */}
        <TextInput
          placeholder="Enter Email"
          placeholderTextColor="#999"
          style={styles.textInput}
          onChangeText={(email) => this.setState({ email })}
        />

        {/* Password requirements info */}
        <Text style={styles.subPasswordText}>Minimum 8 characters | 1 Special character | No spaces</Text>

        {/* Password Input */}
        <View style={styles.passwordContainer}>
          <TextInput
            placeholder="Enter Password"
            placeholderTextColor="#999"
            secureTextEntry={this.state.secureTextEntry}
            style={styles.textInput}
            onChangeText={(password) => this.setState({ password })}
          />
          <TouchableOpacity style={styles.icon} onPress={this.updateSecureTextEntry}>
            {this.state.secureTextEntry ? (
              <Feather name="eye-off" color="#999" size={20} />
            ) : (
              <Feather name="eye" color="#333" size={20} />
            )}
          </TouchableOpacity>
        </View>

        {/* Confirm Password Input */}
        <View style={styles.passwordContainer}>
          <TextInput
            placeholder="Confirm Password"
            placeholderTextColor="#999"
            style={styles.textInput}
            onChangeText={(confirmPw) => this.setState({ confirmPw })}
            secureTextEntry={this.state.confirmSecureTextEntry}
          />
          <TouchableOpacity style={styles.icon} onPress={this.updateConfirmSecureTextEntry}>
            {this.state.confirmSecureTextEntry ? (
              <Feather name="eye-off" color="#999" size={20} />
            ) : (
              <Feather name="eye" color="#333" size={20} />
            )}
          </TouchableOpacity>
        </View>

    {/* User Source Input */}
    <TextInput
  placeholder="How did you hear about us?"
  placeholderTextColor="#999"
  style={styles.textInput}
  value={this.state.userSource}
  onChangeText={(userSource) => this.setState({ userSource })}
/>


        {/* Platform Username Input */}
        <View style={styles.instagramInputRow}>
  <View style={styles.atIconWrapper}>
    <Ionicons name="at-outline" size={24} color="#333" />
  </View>

  <TextInput
    placeholder="Instagram Username"
    placeholderTextColor="#999"
    style={styles.instagramInput}
    onChangeText={(platformUsername) => this.setState({ platformUsername })}
  />
</View>


<View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 20 }}>
  <CheckBox
    value={this.state.isFollowing}
    onValueChange={(newValue) => this.setState({ isFollowing: newValue })}
    style={{
      marginRight: 10,
    }}
  />
  <Text style={{ fontSize: 14, color: 'black' }}>
    I am following collab.bay on Instagram
  </Text>
</View>


        {/* Register Button */}
<TouchableOpacity
  style={[
    styles.registerButton,
    this.state.isSubmitting && { opacity: 0.5 }, // optional fade effect
  ]}
  onPress={this.InsertRecord}
  disabled={this.state.isSubmitting} // ✅ disables the button
>
  <Text style={styles.buttonText}>
    {this.state.isSubmitting ? 'Creating...' : 'Create Account'}
  </Text>
</TouchableOpacity>


        {/* Privacy Policy Link */}
        <TouchableOpacity onPress={() => Linking.openURL('https://collabbay.com/PrivacyPolicy.html')}>
          <Text style={styles.linkText}>By signing up, you agree to our Privacy Policy.</Text>
        </TouchableOpacity>
      </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
  },
  backButton: {
    position: 'absolute',
    top: 40,
    left: 20,
  },
  header: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 8,
    color: 'black',
  },
  subText: {
    fontSize: 14,
    color: '#999',
    marginBottom: 20,
  },
  subPasswordText: {
    fontSize: 12,
    color: '#999',
    padding: 10,
    marginTop: 5,
    marginBottom: 5,
  },
  textInput: {
    width: '80%',
    height: 50,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    marginBottom: 20,
    fontSize: 16,
    paddingHorizontal: 10,
    color: 'black',
  },
  passwordContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  icon: {
    position: 'absolute',
    right: 10,
  },
  registerButton: {
    backgroundColor: '#FDF05D',
    width: '80%',
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,
    marginBottom: 20,
  },
  buttonText: {
    color: 'black',
    fontSize: 18,
  },
  linkText: {
    fontSize: 9,
    color: 'black',
    textDecorationLine: 'underline',
  },
  instagramInputRow: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '80%',
    marginBottom: 20,
  },
  
  atIconWrapper: {
    width: '10%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  
  instagramInput: {
    width: '90%',
    height: 50,
    backgroundColor: '#f3f3f3',
    borderRadius: 25,
    paddingLeft: 20,
    paddingRight: 20,
    fontSize: 16,
    color: 'black',
  },
  
  

});
